// extracted by mini-css-extract-plugin
export default {"amountBoxMainWrapper":"styles_amountBoxMainWrapper__+ZjgZ"};